import axios from 'axios';
import type { FileMeta, WriteUrlResponse } from '../types';


export const getWriteUrl = async (files: FileMeta[], baseURL: string, token: string): Promise<WriteUrlResponse> => {
    const { data } = await axios.post(`${baseURL}/v1/storage/write-urls`, { files }, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
    return data;
};

export const initiateUpload = async (uploadURL: string, mimeType: string): Promise<string> => {
    const response = await axios.post(uploadURL, null, {
        headers: {
            'X-Goog-Resumable': 'start',
            'Content-Type': mimeType,
            'Accept': "*/*"
        },
    });
    return response.headers['location'];
};


export const uploadFile = async (locationURL: string, file: File, onProgress?: (percent: number) => void): Promise<void> => {
    await axios.put(locationURL, file, {
        headers: {
            'Content-Type': file.type,
        },
        onUploadProgress: (event) => {
            if (event.total && onProgress) {
                const percent = Math.round((event.loaded * 100) / event.total);
                onProgress(percent);
            }
        },
    });
};

export const confirmUpload = async (id: string, baseURL: string, token: string): Promise<void> => {
    const body = { id };
    await axios.patch(`${baseURL}/v1/storage/upload/${id}/confirm`, body, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
};